import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/first';
import { Observable } from 'rxjs/Observable';
import { first, take } from 'rxjs/operators';
import {AppService} from '../app.service';
import {TokenStorageService} from '../services/token-storage.service';
import { AuthenticationService } from '../services/authentication.service';
import { Router, ActivatedRoute,NavigationExtras } from '@angular/router';
import { ConstantConfigService } from '../services/constant-config.service';
import { CookieService } from 'ngx-cookie-service';
@Injectable({
    providedIn: 'root'
})
export class VersionCheckService { 
  
    
  //this will be replaced by actual hash post-build.js
    public currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';
    _baseURL : string;
    public href: string = "";
    _accessToken;
    _guestToken;
    _CookieExpireTokenTime; 
    
    //public currentHash = '10939b67d420df57'; 
    //public currentHash = "8b61c7b3d69d81ef";



    constructor(private http: HttpClient,private service : AppService,private tokenStorageService: TokenStorageService,private router: Router, private authService: AuthenticationService,private cookieService: CookieService) {
        this._baseURL = ConstantConfigService.baseURL;
        this.href = this.router.url;
        this._accessToken = ConstantConfigService.accessToken;
        this._guestToken = ConstantConfigService.guestToken;
        this._CookieExpireTokenTime = ConstantConfigService.CookieExpireTokenTime;
    }

    /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */
    initVersionCheck(url, frequency = 1000 * 60 * 30) {
        console.log('checking version');
        setInterval(() => {
            this.checkVersion(url);
        }, frequency);
    }

     /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */

       
    private refreshInterval: any;
    refreshTokens(frequency = 1000 * 60 * 30) {
        if (this.refreshInterval) {
            clearInterval(this.refreshInterval);
        }

        this.refreshInterval = setInterval(() => {
          console.log("In refreshing token");
          var fullRoute = window.location.href;
          
          if (fullRoute.indexOf('free-sign') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('quick-sign') > -1 || fullRoute.indexOf('login') > -1 || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1){
              // Skip refresh for these routes
          } else {
              const authToken = localStorage.getItem(this._accessToken);
              if (this.authService.isAuthenticated() || (authToken!='' && authToken!=null && typeof authToken != 'undefined')) {
                  console.log("In isAuthenticated ");
                  this.refreshServerToken();
              }
          }
        }, frequency);

        // var fullRoute =  window.location.href;
        // setInterval(() => {
        //     console.log("In refershing token");
        //   if (fullRoute.indexOf('free-sign') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('quick-sign') > -1  || fullRoute.indexOf('login') > -1 || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1){
        //   } else {

        //     const authToken = localStorage.getItem(this._accessToken);
        //     if (this.authService.isAuthenticated() || (authToken!='' && authToken!=null && typeof authToken != 'undefined')){
        //         console.log("In isAuthenticated ");
        //       this.refreshServerToken();
        //     }
        //   }
        // }, frequency);
        //600000
    }
    
      
    
    refreshGuestToken(frequency = 1000 * 60 * 2){

      const authToken = localStorage.getItem(this._accessToken);
      console.log('comes inside refresh token ',authToken);
      if (!this.authService.isAuthenticated() || (authToken=='' || authToken==null || typeof authToken == 'undefined')){
          var fullRoute =  window.location.href;
          let intervalid = setInterval(() => {

            //const authToken: any = this.cookieService.get(this._accessToken);
            const authToken = localStorage.getItem(this._accessToken);
            if((authToken=='' || authToken==null)){
              this.service.setLoader(false);
              console.log('refreshing guest token');
              var postdata = {
                "action":'refreshtoken'
              };
              this.http.get(this._baseURL+'/template/gethashToken').subscribe((response: any) => {
                this.tokenStorageService.saveGuestToken(response.g_token,0,0);
                //this.service.setLoader(true);
                },
                (err) => {
                  console.error(err.error.error, 'Could not refresh guest token');
                }
              );
            }
          },frequency);
        return intervalid;
      } else if(this.authService.isAuthenticated() || (authToken!='')){
        localStorage.removeItem(this._guestToken);
	      this.cookieService.delete(this._guestToken);
        return 0;
      }
    }


    private refreshServerToken() {
        // timestamp these requests to invalidate caches
        //console.log(url);
        const oldToken = localStorage.getItem(this._accessToken);
        console.log('OLD TOKEN:', oldToken?.substring(0, 50) + '...'); // Log first 50 chars
    
        var postdata = {
            "action":'refreshtoken'
        };
        let headers = {};
        if (oldToken) {
            headers['Authorization'] = 'Bearer ' + oldToken;
            headers['Content-Type'] = 'application/json';
        }
        
        //console.log('loading token'+this._baseURL)
        this.service.setLoader(false);
        return this.http.post(this._baseURL+'/refresh-just-token',postdata, { headers }).subscribe((response: any) => {
               // console.log("jwtresponse",response.jwt_new_token);
                console.log('NEW TOKEN:', response.jwt_new_token.substring(0, 50) + '...');
                console.log('Token refreshed at:', new Date().toLocaleTimeString());
                this.tokenStorageService.saveToken(response.jwt_new_token,1,1);
                this.service.setLoader(true);
            },
            (err) => {
              this.service.setLoader(true);
              // Handle 401 - token refresh failed, logout user
              if (err.status === 401) {
                this.authService.logout();
              }
                console.error(err, 'Could not refresh jwt token');
            }
         );

    }


      /**
     * Checks in every set frequency the version of frontend application
     * @param url
     * @param {number} frequency - in milliseconds, defaults to 30 minutes
     */

    refreshRequestTokens(frequency = 1000 * 60 * 2) {
      var fullRoute =  window.location.href;
      setInterval(() => {
        if (fullRoute.indexOf('free-sign') > -1 || fullRoute.indexOf('viewdoc') > -1 || fullRoute.indexOf('quick-sign') > -1  || fullRoute.indexOf('edit-document') > -1 || fullRoute.indexOf('signature') > -1 || fullRoute.indexOf('sign') > -1 || fullRoute.indexOf('doc-comments') > -1 || fullRoute.indexOf('upload-doc') > -1 || fullRoute.indexOf('cdk-drag-drop') > -1 || fullRoute.indexOf('login') > -1 || fullRoute.indexOf('download') > -1 || fullRoute.indexOf('preview-document') > -1){
        } else {
          //this.refreshRequestoken();
        }
      }, frequency);
      //600000
  }



    private refreshRequestoken() {
      // timestamp these requests to invalidate caches
      //console.log(url);
      var postdata = {
          "action":'refreshrequesttoken'
      };
      console.log('loading token'+this._baseURL)
      this.service.setLoader(false);
      return this.http.post(this._baseURL+'/refresh-request-token',postdata).subscribe((response: any) => {
              this.tokenStorageService.saveRequestToken(response.api_new_token);
              this.service.setLoader(true);
          },
          (err) => {
              console.error(err, 'Could not refresh request token');
          }
       );

    }


    /**
     * Will do the call and check if the hash has changed or not
     * @param url
     */
    private checkVersion(url) {
        // timestamp these requests to invalidate caches
        //console.log(url);
        this.service.setLoader(false);
        this.http.get(url + '?t=' + new Date().getTime())
            .pipe(first())
            .subscribe(
                (response: any) => {
                    this.service.setLoader(true);
                    const hash = response.hash;
                    console.log("response",response.hash);
                    const hashChanged = this.hasHashChanged(this.currentHash, hash);

                    // If new version, do something
                    if (hashChanged) {
                        console.log("Version Changed",hashChanged);
                        // ENTER YOUR CODE TO DO SOMETHING UPON VERSION CHANGE
                        // for an example: location.reload();
                        location.reload();
                    }
                    // store the new hash so we wouldn't trigger versionChange again
                    // only necessary in case you did not force refresh
                    this.currentHash = hash;
                },
                (err) => {
                    console.error(err, 'Could not get version');
                }
            );
    }

    /**
     * Checks if hash has changed.
     * This file has the JS hash, if it is a different one than in the version.json
     * we are dealing with version change
     * @param currentHash
     * @param newHash
     * @returns {boolean}
     */
    private hasHashChanged(currentHash, newHash) {
        console.log(currentHash, newHash);
        if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
            return false;
        }

        return currentHash !== newHash;
    }
}
